export const documentType = () => [
  { label: "COMPANY LICENSE", value: "COMPANY_LICENSE" },
  { label: "VAT CERTIFICATE", value: "VAT_CERTIFICATE" },
  { label: "PASSPORT", value: "PASSPORT" },
  { label: "EMIRATES ID", value: "EMIRATES_ID" },
];